"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpWidgetSale = void 0;
const gs = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const CmpProductTile_1 = require("./CmpProductTile");
class CmpWidgetSale extends tmpls_1.CmpWidgetSaleBase {
    constructor() {
        super();
        this.fillAsync();
        const slider = this.ctrls.cmpSliderControl.ctrls;
        slider.blockPagintaion.hide();
        slider.label.hide();
        slider.btnNext.onclick = () => this._scrollByOneItem(2);
        slider.btnPrev.onclick = () => this._scrollByOneItem(-2);
    }
    fillAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const products = yield App_1.App.Inst.api.directoryService.getProductsRandom(15);
            if (!products)
                return;
            this.ctrls.listProducts.html = '';
            for (const prod of products) {
                let item = new CmpProductTile_1.CmpProductTile();
                item.fill(prod);
                this.ctrls.listProducts.append(item);
            }
            gs.StateGS.CatchLinks();
        });
    }
    _scrollByOneItem(delta) {
        const style = getComputedStyle(this.ctrls.listProducts.el);
        const gap = parseInt(style.columnGap || style.gap || 0);
        const firstItem = this.ctrls.listProducts.el.children[0];
        const itemWidth = firstItem.offsetWidth + parseInt(getComputedStyle(firstItem).marginRight) + gap;
        this.ctrls.listProducts.el.scrollBy({ left: itemWidth * delta, behavior: "smooth" });
    }
}
exports.CmpWidgetSale = CmpWidgetSale;
//# sourceMappingURL=CmpWidgetSale.js.map